import { useState } from "react";
import { useTranslation } from "react-i18next";
import { categories } from "@/data/categories";

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative w-full">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-3 whitespace-nowrap rounded-lg border border-background-300/60 bg-background-50 px-4 py-3 text-left text-sm font-medium text-foreground-800 hover:border-primary-400 cursor-pointer transition-colors"
      >
        <span className="flex items-center gap-2">
          <i className="ri-apps-2-line text-primary-600"></i>
          <span>{t("hero.dropdownPlaceholder")}</span>
        </span>
        <i
          className={`ri-arrow-down-s-line text-foreground-500 transition-transform ${
            open ? "rotate-180" : ""
          }`}
        ></i>
      </button>

      {open && (
        <div className="absolute left-0 right-0 top-full z-30 mt-2 max-h-72 overflow-y-auto rounded-lg border border-background-200 bg-background-50">
          {categories.map((c) => (
            <a
              key={c.key}
              href={c.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center justify-between gap-3 whitespace-nowrap px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-100 cursor-pointer transition-colors"
            >
              <span>{t(`categories.${c.key}`)}</span>
              <i className="ri-arrow-right-up-line text-foreground-400 text-xs"></i>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}